import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import store from "../store";
import home from "../pages/home/index.vue";

const routes: Array<RouteRecordRaw> = [
  { path: "/", name: "home", component: home },
  {
    path: "/login",
    name: "login",
    component: () => import("../pages/login/index.vue"),
  },
  {
    path: "/laundering",
    name: "laundering",
    component: () => import("../pages/laundering/index.vue"),
  },
  {
    path: "/help",
    name: "help",
    component: () => import("../pages/help/index.vue"),
  },
  {
    path: "/notfound",
    name: "notfound",
    component: () => import("../pages/notfound/index.vue"),
  },
  {
    path: "/commitment-letter",
    name: "commitment-letter",
    component: () => import("../pages/CommitmentLetter/CommitmentLetter.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (
    (await store.dispatch("getToken")) &&
    (await store.dispatch("getProfile"))
  ) {
    if (to.name === "login") {
      return next({
        name: "home",
        replace: true,
      });
    }
  } else {
    if (to.name === "home") {
      return next({
        name: "login",
        replace: true,
      });
    }
  }
  next();
});

export default router;
